/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-10-27 11:39:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import RuleBasedItemContainer from 'src/components/containers/recommendation/widget/item/general/rule-based-item-container';
import { reorder } from 'src/helpers';

import { RECOMMENDATION_WIDGET_LIMIT_RULE_BASED_RECOMMENDATION as LIMIT_RULE_BASED } from 'src/constants/recommendation';

import type { RuleBaseType } from 'src/models/recommendation';

type Props = {
  ruleBasedList: RuleBaseType,
  updateField: Function
};

type ComposedProps = WithI18nProps & Props;

class RuleBasedList extends Component<ComposedProps> {
  render() {
    const { ruleBasedList, updateField } = this.props;
    const ruleBasedListEnabled = _.filter(ruleBasedList, ruleBased => ruleBased.status);
    const isLimitRuleBased = ruleBasedListEnabled.length >= LIMIT_RULE_BASED;

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppableList">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="BC-Draggable__Container">
              {ruleBasedList.map((rule, index) => (
                <Draggable key={rule.id} draggableId={rule.id} index={index}>
                  {(provided, snapshot) => {
                    return (
                      <div ref={provided.innerRef} {...provided.draggableProps}>
                        <RuleBasedItemContainer
                          rule={rule}
                          index={index}
                          dragHandleProps={provided.dragHandleProps}
                          updateField={updateField}
                          isLimitRuleBased={isLimitRuleBased}
                        />
                      </div>
                    );
                  }}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  // Handle drag and drop
  onDragEnd = (result: DropResult) => {
    // dropped outside the list
    if (!result.destination || result.destination.index === result.source.index) {
      return;
    }

    // reorder index of rules and update
    const { ruleBasedList, updateField } = this.props;
    const reorderedRuleBasedLists = reorder(
      ruleBasedList,
      result.source.index,
      result.destination.index
    );
    updateField('ruleBasedList', reorderedRuleBasedLists);
  };
}

export default withI18n()(RuleBasedList);
